// ---------------------------------------------
// auto-generated from screens/course.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { Icon, Chip, Eyebrow, SourceRail, StatusBar, Candles, genCandles, NotAdvice } from "./primitives.jsx";

// ─────────────────────────────────────────────────────────
//  1. Course / Hub / Overview
// ─────────────────────────────────────────────────────────
export const ScreenCourseHub = () => (
  <div className="screen-m ef" data-screen-label="Course · Hub Overview">
    <StatusBar/>
    {/* Header */}
    <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="back" size={14}/></button>
      <Chip>COURSE · iniciación</Chip>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="more" size={14}/></button>
    </div>

    {/* Title */}
    <div style={{ padding: "16px 22px 0" }}>
      <Eyebrow>Análisis técnico · iniciación · ~5 h</Eyebrow>
      <div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.025em", marginTop: 8, textWrap: "balance" }}>
        Leer gráficos sin <span style={{ color: "var(--accent)" }}>autoengañarse</span>.
      </div>
      <div style={{ fontSize: 13, color: "var(--text-2)", marginTop: 8, lineHeight: 1.4, textWrap: "pretty" }}>
        Vas a leer velas, volumen y timeframes con criterio prudente.
      </div>
    </div>

    {/* progress + mastery */}
    <div style={{ padding: "16px 18px 0" }}>
      <div className="glass" style={{ padding: 14, borderRadius: 14 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Eyebrow>Progreso · 0%</Eyebrow>
          <Chip variant="neutral">mastery objetivo 80%</Chip>
        </div>
        <div style={{ height: 4, background: "rgba(168,185,217,0.15)", borderRadius: 2, marginTop: 10, overflow: "hidden" }}>
          <div style={{ width: "0%", height: "100%", background: "var(--accent)" }}></div>
        </div>
        <div style={{ display: "flex", marginTop: 10, gap: 8 }}>
          {[
            { l: "M1", on: true, t: "Qué es AT" },
            { l: "M2", t: "Anatomía" },
            { l: "M3", t: "Tendencias" },
            { l: "M4", t: "S/R" },
            { l: "M5", t: "Volumen" },
            { l: "M6", t: "Proyecto", proj: true },
          ].map((m, i) => (
            <div key={i} style={{ flex: 1, textAlign: "center" }}>
              <div style={{
                width: "100%", height: 4, borderRadius: 2,
                background: m.on ? "var(--accent)" : m.proj ? "rgba(127,182,255,0.4)" : "rgba(168,185,217,0.12)"
              }}/>
              <div className="mono" style={{ fontSize: 9, marginTop: 4, color: m.on ? "var(--accent)" : "var(--text-3)", letterSpacing: "0.06em" }}>{m.l}</div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* objectives */}
    <div style={{ padding: "16px 22px 0" }}>
      <Eyebrow>Objetivos clave</Eyebrow>
      <ul style={{ listStyle: "none", padding: 0, marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
        {[
          "Separar AT de predicción",
          "Leer vela, OHLC, volumen y timeframe",
          "Identificar tendencias por estructura",
          "Dibujar soportes como zonas",
          "Producir un mapa técnico prudente",
        ].map((t, i) => (
          <li key={i} style={{ display: "flex", gap: 10, fontSize: 12.5, color: "var(--text)", lineHeight: 1.35 }}>
            <span className="mono" style={{ color: "var(--text-3)", width: 18, flexShrink: 0, fontSize: 10 }}>0{i+1}</span>
            <span style={{ textWrap: "pretty" }}>{t}</span>
          </li>
        ))}
      </ul>
    </div>

    {/* Errors avoided */}
    <div style={{ padding: "14px 18px 0" }}>
      <div className="misconception-card">
        <div className="lbl">Errores que evitarás</div>
        <ul style={{ listStyle: "none", padding: 0, marginTop: 6, display: "flex", flexDirection: "column", gap: 4 }}>
          {["AT no predice con certeza", "Más líneas no es mejor análisis", "Una vela aislada no basta"].map((t, i) => (
            <li key={i} style={{ fontSize: 12, color: "var(--text)", display: "flex", gap: 8 }}>
              <span style={{ color: "var(--warn)" }}>·</span>{t}
            </li>
          ))}
        </ul>
      </div>
    </div>

    {/* Project preview */}
    <div style={{ padding: "12px 18px 0" }}>
      <div style={{
        background: "linear-gradient(120deg, rgba(127,182,255,0.1), rgba(95,214,193,0.06))",
        border: "1px dashed rgba(127,182,255,0.35)", borderRadius: 12, padding: 12,
        display: "flex", gap: 10, alignItems: "center"
      }}>
        <Icon name="diamond" size={16} style={{ color: "var(--primary)" }}/>
        <div style={{ flex: 1 }}>
          <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: "var(--primary)" }}>PROYECTO FINAL</div>
          <div style={{ fontSize: 12.5, marginTop: 3, lineHeight: 1.3 }}>Mapa técnico simple de un activo no visto</div>
        </div>
      </div>
    </div>

    <div style={{ position: "absolute", bottom: 40, left: 18, right: 18 }}>
      <button className="btn primary" style={{ width: "100%" }}>
        <Icon name="play" size={13}/> Empezar · diagnóstico 4 min
      </button>
      <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 10, alignItems: "center" }}>
        <Icon name="shield" size={12} style={{ color: "var(--text-3)" }}/>
        <NotAdvice>Certificado pedagógico · no financiero</NotAdvice>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────
//  2. Course / Module / Overview
// ─────────────────────────────────────────────────────────
export const ScreenCourseModule = () => (
  <div className="screen-m ef" data-screen-label="Course · Module M2 Overview">
    <StatusBar/>
    <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="back" size={14}/></button>
      <Chip>MÓDULO · M2 de 6</Chip>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="map" size={14}/></button>
    </div>

    {/* Title */}
    <div style={{ padding: "16px 22px 0" }}>
      <Eyebrow>M2 · 35 min</Eyebrow>
      <div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.025em", marginTop: 8 }}>
        Anatomía del <span style={{ color: "var(--accent)" }}>gráfico</span>
      </div>
    </div>

    {/* Objectives + misconceptions split */}
    <div style={{ padding: "16px 18px 0" }}>
      <div className="glass" style={{ padding: 14, borderRadius: 12 }}>
        <Eyebrow>Objetivos</Eyebrow>
        <ul style={{ listStyle: "none", padding: 0, marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
          {["Leer vela y OHLC", "Entender volumen y timeframe"].map((t, i) => (
            <li key={i} style={{ display: "flex", gap: 10, fontSize: 13, lineHeight: 1.35 }}>
              <Icon name="check" size={13} style={{ color: "var(--accent)", marginTop: 3 }}/>
              <span>{t}</span>
            </li>
          ))}
        </ul>
        <div style={{ height: 1, background: "var(--line)", margin: "12px 0" }}></div>
        <Eyebrow>Errores que evitas</Eyebrow>
        <ul style={{ listStyle: "none", padding: 0, marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
          {["Confundir cuerpo y mecha", "Confundir timeframe y tendencia"].map((t, i) => (
            <li key={i} style={{ display: "flex", gap: 10, fontSize: 13, lineHeight: 1.35, color: "var(--text-2)" }}>
              <Icon name="x" size={13} style={{ color: "var(--warn)", marginTop: 3 }}/>
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>

    {/* Agenda */}
    <div style={{ padding: "14px 18px 0" }}>
      <Eyebrow>Agenda</Eyebrow>
      <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
        {[
          { n: "1", t: "Microclase", d: "6 min", i: "movie", on: true },
          { n: "2", t: "Lab · construir vela desde OHLC", d: "10 min", i: "draw" },
          { n: "3", t: "Caso vivo (si hay)", d: "~5 min", i: "globe", live: true },
          { n: "4", t: "Mastery check", d: "5 min", i: "target" },
          { n: "5", t: "Retention loop", d: "mañana", i: "spark", future: true },
        ].map((s, i) => (
          <div key={i} className="glass" style={{
            padding: "10px 12px", borderRadius: 10, display: "flex", alignItems: "center", gap: 10,
            borderColor: s.on ? "rgba(127,182,255,0.45)" : "var(--line)",
            background: s.on ? "rgba(127,182,255,0.08)" : "rgba(23,42,79,0.5)",
          }}>
            <span className="mono" style={{ width: 18, fontSize: 11, color: s.on ? "var(--primary)" : "var(--text-3)" }}>{s.n}</span>
            <Icon name={s.i} size={14} style={{ color: s.future ? "var(--text-3)" : s.live ? "var(--accent)" : s.on ? "var(--primary)" : "var(--text-2)" }}/>
            <span style={{ flex: 1, fontSize: 12.5, color: s.future ? "var(--text-3)" : "var(--text)" }}>{s.t}</span>
            {s.live && <Chip variant="live">live</Chip>}
            <span className="mono" style={{ fontSize: 9.5, color: "var(--text-3)" }}>{s.d}</span>
          </div>
        ))}
      </div>
    </div>

    {/* Tutor strip */}
    <div style={{ padding: "12px 18px 0" }}>
      <div className="glass" style={{
        padding: 12, borderRadius: 12, display: "flex", alignItems: "center", gap: 10,
        border: "1px solid rgba(95,214,193,0.28)"
      }}>
        <div style={{ width: 32, height: 32, borderRadius: 99, background: "rgba(95,214,193,0.16)", display: "grid", placeItems: "center" }}>
          <Icon name="help" size={14} style={{ color: "var(--accent)" }}/>
        </div>
        <div style={{ flex: 1 }}>
          <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: "var(--accent)" }}>TUTOR · profesor_analista</div>
          <div style={{ fontSize: 12, color: "var(--text-2)", marginTop: 3 }}>Siempre contextual · sin recomendaciones</div>
        </div>
        <Icon name="shield" size={14} style={{ color: "var(--text-3)" }}/>
      </div>
    </div>

    <div style={{ position: "absolute", bottom: 40, left: 18, right: 18 }}>
      <button className="btn primary" style={{ width: "100%" }}>
        <Icon name="play" size={13}/> Empezar microclase
      </button>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
        <NotAdvice/>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────
//  3. Course / Module / MasteryCheck
// ─────────────────────────────────────────────────────────
export const ScreenCourseMastery = () => {
  const data = React.useMemo(() => genCandles(24, 17, { trend: 0.5, vol: 1.1 }), []);
  return (
    <div className="screen-m ef" data-screen-label="Course · MasteryCheck">
      <StatusBar/>
      <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="x" size={14}/></button>
        <Chip variant="warn">MASTERY · M2</Chip>
        <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="help" size={14}/></button>
      </div>

      {/* Mastery meter */}
      <div style={{ padding: "14px 18px 0" }}>
        <div className="glass" style={{ padding: 14, borderRadius: 12 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: "var(--text-3)" }}>MASTERY METER</div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginTop: 4 }}>
                <span style={{ fontSize: 22, fontWeight: 600, color: "var(--text)" }} className="mono">72%</span>
                <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>/ 80% threshold</span>
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--text-3)" }}>EJERCICIO</div>
              <div style={{ fontSize: 14, fontWeight: 600, marginTop: 2 }}>6 <span style={{ color: "var(--text-3)" }}>de 8</span></div>
            </div>
          </div>
          <div style={{ height: 6, background: "rgba(168,185,217,0.12)", borderRadius: 99, marginTop: 12, position: "relative", overflow: "hidden" }}>
            <div style={{ width: "72%", height: "100%", background: "linear-gradient(90deg, var(--primary), var(--accent))", borderRadius: 99 }}></div>
            <div style={{ position: "absolute", left: "80%", top: -2, bottom: -2, width: 2, background: "var(--warn)" }}></div>
          </div>
          <div style={{ marginTop: 8, fontSize: 11.5, color: "var(--text-2)" }}>
            Falta <span style={{ color: "var(--text)" }}>1 acierto + 1 transferencia</span> para desbloquear M3.
          </div>
        </div>
      </div>

      {/* exercise · chart labeling */}
      <div style={{ padding: "14px 18px 0" }}>
        <Eyebrow>Chart labeling · 6 de 8</Eyebrow>
        <div style={{ fontSize: 15, fontWeight: 600, marginTop: 6, lineHeight: 1.3, letterSpacing: "-0.01em", textWrap: "balance" }}>
          Toca el <span style={{ color: "var(--accent)" }}>HL</span> que mantiene la tendencia.
        </div>
      </div>

      <div style={{ padding: "10px 18px 0" }}>
        <div className="glass" style={{ borderRadius: 12, overflow: "hidden", position: "relative" }}>
          <Candles data={data} width={354} height={180} padding={8}/>
          {[
            { i: 4, low: true, label: "1" },
            { i: 10, low: true, label: "2", glow: true },
            { i: 15, low: false, label: "3" },
            { i: 20, low: true, label: "4" },
          ].map((s, k) => {
            const min = Math.min(...data.map(d => d.l));
            const max = Math.max(...data.map(d => d.h));
            const span = max - min || 1;
            const w = (354 - 16) / data.length;
            const x = 8 + s.i * w + w / 2;
            const py = s.low ? data[s.i].l : data[s.i].h;
            const y = 8 + (1 - (py - min) / span) * (180 - 16);
            return (
              <div key={k} style={{
                position: "absolute",
                left: x - 18, top: y - 18, width: 36, height: 36,
                borderRadius: 99,
                border: `1.5px solid ${s.glow ? "var(--accent)" : "rgba(127,182,255,0.5)"}`,
                background: s.glow ? "rgba(95,214,193,0.16)" : "rgba(127,182,255,0.10)",
                display: "grid", placeItems: "center",
                boxShadow: s.glow ? "0 0 16px rgba(95,214,193,0.4)" : "none",
              }}>
                <span className="mono" style={{ fontSize: 11, color: s.glow ? "var(--accent)" : "var(--primary)" }}>{s.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* labels */}
      <div style={{ padding: "12px 18px 0" }}>
        <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: "var(--text-3)" }}>LABELS DISPONIBLES</div>
        <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
          {[
            { l: "HH", c: "var(--accent)" },
            { l: "HL", c: "var(--accent)", on: true },
            { l: "LH", c: "var(--negative)" },
            { l: "LL", c: "var(--negative)" },
          ].map((b, i) => (
            <button key={i} className="chip" style={{
              height: 30, padding: "0 14px", fontSize: 12,
              borderColor: b.on ? b.c : "var(--line)",
              background: b.on ? `color-mix(in oklab, ${b.c} 18%, transparent)` : "rgba(168,185,217,0.06)",
              color: b.on ? b.c : "var(--text-2)",
            }}>{b.l}</button>
          ))}
          <button className="chip" style={{ height: 30, marginLeft: "auto", borderStyle: "dashed", color: "var(--text-3)" }}>
            <Icon name="list" size={10}/> tabla accesible
          </button>
        </div>
      </div>

      {/* secondary actions */}
      <div style={{ padding: "14px 18px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="lightbulb" size={12}/> Pista 1/3</button>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="book" size={12}/></button>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="link" size={12}/></button>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="help" size={12}/></button>
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 80, left: 18, right: 18 }}>
        <button className="btn primary" style={{ width: "100%" }}>
          <Icon name="check" size={13}/> Enviar respuesta
        </button>
      </div>
      <ExplicaSourceRailEdu_local/>
    </div>
  );
};

// local source rail (since explica file's local var isn't shared)
export const ExplicaSourceRailEdu_local = () => (
  <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
    <SourceRail source="vendor_primary · ABC 1D" time="13:55 UTC"/>
  </div>
);
